export default "<div class=\"spinner-wrapper\" *ngIf=\"loading\">\n    <div class=\"spinner\"></div>\n</div>\n";